import React from "react";
//Utils
import { RenderIf } from "../utils/RenderIf";
import { buildCloudinaryImageUrl } from '../../utils/CloudinaryImageUrl';
//IMG
import defaultImage from "../../assets/img/default.png";


const PlaceholderIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#ccc" strokeWidth="1.5">
        <rect x="3" y="3" width="18" height="18" rx="3" />
        <circle cx="8.5" cy="8.5" r="1.5" />
        <path d="m21 15-5-5L5 21" />
    </svg>
);
export default function OrderPreview({ order, paymentAuthorization }) {
    const paymentStatus = paymentAuthorization.statuses[order?.table_session_uuid];
    const authorizingPayment = paymentStatus === "pending";
    const paymentAuthorized = paymentStatus === "authorized";

    if (!order) {
        return (
            <div className="p-4 text-center" style={{ color: '#222' }}>
                <span className="fw-bold">Selecciona una orden para ver el detalle.</span>
            </div>
        );
    }

    // Waiter-controlled payment gate (ecommerce Pagar button) - only meaningful for a precuenta
    // that came from a table_session (the customer's own phone); a walk-in/call-center precuenta
    // has no ecommerce side to authorize.
    const authorizeOnlinePayment = () => paymentAuthorization.authorize(order.table_session_uuid);

    return (

        <>

            {/* New Style */}
            <div className="precuenta-detail__header">
                <span className="precuenta-detail__title">Orden #{order.transaction_code || order.code}</span>
                <div className="precuenta-detail__meta">
                    <span className="precuenta-detail__meta-item">
                        Notificador: <span className="precuenta-detail__meta-val"># {order.locator || 0}</span>
                    </span>
                    <span className="precuenta-detail__meta-item">
                        Sucursal: <span className="precuenta-detail__meta-val">{order.branchoffice?.name}</span>
                    </span>
                    {/* <span className="precuenta-detail__meta-item">
                        Cajera: <span className="precuenta-detail__meta-val">{order.user?.name}</span>
                    </span> */}
                    <span className="precuenta-detail__meta-item">
                        Usuario: <span className="precuenta-detail__meta-val">{order.machine_name} / {order.user?.name}</span>
                    </span>

                    {order.table_name && (
                        <span className="precuenta-detail__meta-item">
                            Mesa: <span className="precuenta-detail__meta-val">{order.table_name}</span>
                        </span>
                    )}

                    <span className="precuenta-detail__meta-item">
                        Máq: <span className="precuenta-detail__meta-val">{order.machine_code}</span>
                    </span>
                </div>

                {order.table_session_uuid ? (
                    <button
                        type="button"
                        className="precuenta-btn-secondary mt-2"
                        onClick={authorizeOnlinePayment}
                        disabled={authorizingPayment || paymentAuthorized}
                        title="Habilita el boton Pagar en el celular del cliente"
                    >
                        <i className={`bi ${paymentAuthorized ? "bi-check-circle-fill" : "bi-phone"}`} />
                        {" "}
                        {paymentAuthorized ? "Pago habilitado" : "Habilitar pago en linea"}
                    </button>
                ) : null}
            </div>

            <div className="precuenta-products">
                <p className="precuenta-products__label">Productos</p>
                {order.groups?.map((prod) => (
                    <div key={prod.id} className="precuenta-product ">
                        <div className="precuenta-product__thumb">
                            {prod.img ? (
                                <img loading="eager" src={buildCloudinaryImageUrl({ url: prod.img, width: 300, quality: "auto", type: "image" }) || defaultImage} alt={prod.name} />
                            ) : (
                                <PlaceholderIcon />
                            )}
                        </div>
                        <div className="precuenta-product__info d-flex flex-column align-items-start">
                            <p className="precuenta-product__name">{prod.name}</p>
                            <p className="precuenta-product__qty">x{prod.amount}</p>
                        </div>
                        <span className="precuenta-product__price">
                            {((Number(prod.price) || 0) * prod.amount).toFixed(2)}
                        </span>
                    </div>
                ))}
            </div>

            <div className="precuenta-totals">
            
                <div className="precuenta-totals__row">
                    <span className="precuenta-totals__label">Subtotal</span>
                    <span className="precuenta-totals__value">${(Number(order.subtotal) || 0).toFixed(2)}</span>
                </div>
                <div className="precuenta-totals__row">
                    <span className="precuenta-totals__label">Descuento</span>
                    <span className="precuenta-totals__value precuenta-totals__value--green">
                        ${(Number(order.discount) || 0).toFixed(2)}
                    </span>
                </div>
                <div className="precuenta-totals__final">
                    <span className="precuenta-totals__final-label">Total</span>
                    <span className="precuenta-totals__final-value">${(Number(order.total) || 0).toFixed(2)}</span>
                </div>
            </div>

            {/* Old Style */}
            <div className="order-preview-container p-4 rounded-4 shadow-sm bg-white d-none" style={{ color: '#222', minHeight: 400 }}>
                {/* Información superior en grid tipo cuadrantes */}
                <div className="mb-3 ">
                    <div className="fw-bold text-primary mb-2" style={{ fontSize: 16 }}>Información</div>
                    <div className="row g-2 mb-2">
                        <div className="col-6 col-md-3">
                            <div className="border rounded-3 p-2 text-center bg-light">
                                <div className="text-muted small">Notificador</div>
                                <div className="fw-bold" style={{ fontSize: 18 }}># {order.locator || 0}</div>
                            </div>
                        </div>
                        <div className="col-6 col-md-3">
                            <div className="border rounded-3 p-2 text-center bg-light">
                                <div className="text-muted small">Orden</div>
                                <div className="fw-bold" style={{ fontSize: 18 }}>#{order.transaction_code || order.code}</div>
                            </div>
                        </div>
                        <div className="col-6 col-md-3">
                            <div className="border rounded-3 p-2 text-center bg-light">
                                <div className="text-muted small">Sucursal</div>
                                <div className="fw-bold" style={{ fontSize: 18 }}>{order.branchoffice?.name}</div>
                            </div>
                        </div>
                        <div className="col-6 col-md-3">
                            <div className="border rounded-3 p-2 text-center bg-light">
                                <div className="text-muted small">Usuario</div>
                                <div className="fw-bold" style={{ fontSize: 16 }}>{order.machine_name} / {order.user?.name}</div>
                            </div>
                        </div>
                        <div className="col-6 col-md-3 mt-2 mt-md-0">
                            <div className="border rounded-3 p-2 text-center bg-light">
                                <div className="text-muted small">Máquina</div>
                                <div className="fw-bold" style={{ fontSize: 18 }}>{order.machine_code}</div>
                            </div>
                        </div>

                        <RenderIf isTrue={order.table_name}>
                            <div className="col-6 col-md-3 mt-2 mt-md-0">
                                <div className="border rounded-3 p-2 text-center bg-light">
                                    <div className="text-muted small">Mesa</div>
                                    <div className="fw-bold" style={{ fontSize: 18 }}>{order.table_name}</div>
                                </div>
                            </div></RenderIf>
                    </div>

                </div>
            </div>
        </>

    );
}
